var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShipOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1767862424563,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1865,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M311 709.96c-73.12 0-143.04-41.16-176.6-109.44l-72.8-148.08a36.024 36.024 0 0 1-0.76-30.12 35.948 35.948 0 0 1 22.36-20.16l66.08-20.56c10.28-3.2 21.44-1.64 30.44 4.28l122.64 80.4 75.08-24.28-182.92-261.36c-7.68-11-8.64-25.36-2.44-37.28S210.6 124 224 124h128c8.8 0 17.32 3.24 23.92 9.08L631.2 360l116.08-37.52c82.12-26.76 172.88 11.56 211 89.16 10.48 21.36 11.2 46.16 1.96 68.08s-27.52 38.72-50.12 46.08L370.72 700.56a193.928 193.928 0 0 1-59.68 9.44z m-166.24-251.52l54.24 110.32c27 54.92 91.28 82.12 149.52 63.28l539.36-174.76c3.72-1.2 5.4-4.04 6.04-5.6 0.68-1.56 1.52-4.72-0.24-8.28-22.44-45.64-75.8-68.16-124.16-52.4l-135.76 43.88c-12.16 3.92-25.44 1.12-35-7.36L338.32 196H293.16l171.24 244.64a35.928 35.928 0 0 1 4.64 32.08 36.036 36.036 0 0 1-23.04 22.8l-137.84 44.56c-10.36 3.36-21.68 1.84-30.8-4.16l-122.84-80.52-9.72 3.04zM928 900H96a36 36 0 0 1 0-72h832a36 36 0 0 1 0 72z",
    fill: "#ffffff",
    "p-id": 1866
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipOut);
export default __webpack_public_path__ + "static/media/shipOut.e178c8e47c66fecc3d95c5e479374cbf.svg";
export { ForwardRef as ReactComponent };